/*eslint-disable */

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useToasts } from 'react-toast-notifications';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import ClipLoader from 'react-spinners/ClipLoader';

import ActionCreators from '../../actions';
import { getQuestionnaireQuestions, submitQuestionnaire, fetchQuestionnaireQuestions } from '../../actions/questionnaire';
import { CarInsuranceQuestionnaireScreen } from '../../Screens';
import QuestionnaireThankYouModal from '../../Components/QuestionnaireThankYouModal';

const questions = [
  {
    "id": 1,
    "questionText": "Do you currently have car insurance?",
    "questionType": "radio",
    "options": [
      "yes",
      "no"
    ],
    "formVersion": 1,
    "createdAt": "2025-06-26T11:32:27.001Z",
    "updatedAt": "2025-06-26T11:32:27.001Z",
    "deletedAt": null
  },
  {
    "id": 2,
    "questionText": "Would you be interested in shopping for car insurance?",
    "questionType": "radio",
    "options": [
      "yes",
      "no"
    ],
    "formVersion": 1,
    "createdAt": "2025-06-26T11:32:27.001Z",
    "updatedAt": "2025-06-26T11:32:27.001Z",
    "deletedAt": null
  },
  {
    "id": 3,
    "questionText": "When are you looking to start a new policy?",
    "questionType": "check",
    "options": [
      "Better price",
      "New driver / new car",
      "Policy is expiring",
      "Not happy with current provider",
      "Just curious / no urgent need"
    ],
    "formVersion": 1,
    "createdAt": "2025-06-26T11:32:27.001Z",
    "updatedAt": "2025-06-26T11:32:27.001Z",
    "deletedAt": null
  },
  {
    "id": 4,
    "questionText": "Why would you shop for car insurance?",
    "questionType": "radio",
    "options": [
      "Immediately",
      "Within 30 days",
      "1–3 months",
      "No timeline",
      "Just browsing"
    ],
    "formVersion": 1,
    "createdAt": "2025-06-26T11:32:27.001Z",
    "updatedAt": "2025-06-26T11:32:27.001Z",
    "deletedAt": null
  },
  {
    "id": 5,
    "questionText": "Do you currently have car insurance?",
    "questionType": "radio",
    "options": [
      "<$75",
      "$75–125",
      "$126–200",
      "$200+",
      "Not sure"
    ],
    "formVersion": 1,
    "createdAt": "2025-06-26T11:32:27.001Z",
    "updatedAt": "2025-06-26T11:32:27.001Z",
    "deletedAt": null
  },
  {
    "id": 6,
    "questionText": "Would you like to be contacted for a better insurance offer?",
    "questionType": "radio",
    "options": [
      "yes",
      "no"
    ],
    "formVersion": 1,
    "createdAt": "2025-06-26T11:32:27.001Z",
    "updatedAt": "2025-06-26T11:32:27.001Z",
    "deletedAt": null
  }
]


const CarInsuranceQuestionnaireContainer = ({ currentUser }) => {
  const { addToast } = useToasts();
  const history = useHistory();
  const { inspectionId, vehicleId } = useParams();
  const dispatch = useDispatch();
  console.log({inspectionId, vehicleId});

  const { questions, loading: questionsLoading, error: questionsError } = useSelector(state => state.questionnaire);

  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  useEffect(() => {
    dispatch(fetchQuestionnaireQuestions(1));
  }, [dispatch]);

  const handleAnswerChange = (questionId, questionType, option) => {
    setAnswers(prevAnswers => {
      const newAnswers = {...prevAnswers};
      if (questionType === 'radio') {
        newAnswers[questionId] = option;
      } else if (questionType === 'check') {
        const currentOptions = newAnswers[questionId] || [];
        if (currentOptions.includes(option)) {
          newAnswers[questionId] = currentOptions.filter(item => item !== option);
        } else {
          newAnswers[questionId] = [...currentOptions, option];
        }
      }

      if (questionId === 1 && option === 'no') {
        questions.slice(1).forEach(q => {
          if (q.id !== 2) {
            delete newAnswers[q.id];
          }
        });
      }

      return newAnswers;
    });
  };

const handleSubmit = () => {
    let responses = Object.keys(answers).map(questionId => ({
      questionId: parseInt(questionId),
      answer: answers[questionId],
    }));

    const question2Answer = answers['2'] || answers[2];
    if (question2Answer === 'no') {
      responses = responses.filter(response => response.questionId <= 2);
    }

    const data = {
      formVersion: 1,
      inspectionId: parseInt(inspectionId),
      vehicleId: parseInt(vehicleId),
      responses: responses,
    }

    dispatch(submitQuestionnaire(data, history, addToast, setLoading, () => setShowThankYou(true)));
  }

  const handleContinue = () => {
    setShowThankYou(false);
    history.push("/thankyouScreen");
  };

  let questionsToDisplay = questions.slice(0, 2);
  if (answers[2] === 'yes') {
    questionsToDisplay = questions;
  }

  // Validation: Only enable submit if all displayed questions are answered
  const requiredQuestionIds = questionsToDisplay.map(q => q.id);
  const canSubmit = requiredQuestionIds.every(qid => {
    const answer = answers[qid];
    if (answer === undefined || answer === null) return false;
    if (Array.isArray(answer)) return answer.length > 0;
    return !!answer;
  });

  if (questionsLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <ClipLoader color={'#FF7A00'} size={48} />
      </div>
    );
  }
  if (questionsError) {
    return <div style={{color: 'red', textAlign: 'center', padding: '2rem'}}>{questionsError}</div>;
  }

  return (
    <>
      <CarInsuranceQuestionnaireScreen
        questions={questionsToDisplay}
        answers={answers}
        handleAnswerChange={handleAnswerChange}
        handleSubmit={handleSubmit}
        loading={loading}
        canSubmit={canSubmit}
      />
      {showThankYou && (
        <QuestionnaireThankYouModal onContinue={handleContinue} />
      )}
    </>
  );
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ ...ActionCreators, submitQuestionnaire }, dispatch);
  }

  function mapStateToProps(state) {
    return {
      currentUser: state.auth.currentUser,
    };
  }
  export default connect(mapStateToProps, mapDispatchToProps)(CarInsuranceQuestionnaireContainer);
